import { styled } from "tamagui";
import { Progress as TamaguiProgress } from "@tamagui/progress";
const StyledProgress = styled(TamaguiProgress, {
  backgroundColor: "$surface0Hover",
  borderRadius: "$brFull",
  height: "$si0.5",
  overflow: "hidden",
  width: "100%"
});
const StyledIndicator = styled(TamaguiProgress.Indicator, {
  backgroundColor: "$surfaceStrong",
  borderRadius: "$brFull"
});
export type ProgressBarProps = {
  /**
   * Current progress value (0–100).
   */
  value: number;
  /**
   * Accessible label describing the progress.
   * Defaults to a percentage string (e.g. "50%").
   */
  getValueLabel?: (value: number, max: number) => string;
};
export const ProgressBar = ({
  value,
  getValueLabel
}: ProgressBarProps) => {
  return <StyledProgress value={value} getValueLabel={getValueLabel} data-sentry-element="StyledProgress" data-sentry-component="ProgressBar" data-sentry-source-file="ProgressBar.tsx">
      <StyledIndicator transition="300ms ease" data-sentry-element="StyledIndicator" data-sentry-source-file="ProgressBar.tsx" />
    </StyledProgress>;
};